// extracted by mini-css-extract-plugin
export default {"hover-localization-menu-footer":"hover-localization-menu-footer--kCm7S","hoverLocalizationMenuFooter":"hover-localization-menu-footer--kCm7S"};